import { render } from "./MyPageWithdraw.vue?vue&type=template&id=c8f4963e"
import script from "./MyPageWithdraw.vue?vue&type=script&lang=js"
export * from "./MyPageWithdraw.vue?vue&type=script&lang=js"

import "./MyPageWithdraw.vue?vue&type=style&index=0&id=c8f4963e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__